export default __webpack_public_path__ + "static/media/logo-algostudy-n@3x.a5dea00b.webp";